<template>
			<div class="content">
        <s-location buy title="기간별 영수증 출력"/>

				<h4 class="sub_title02" >경유회비 영수증</h4>

					<div class="btn_group mt0">
            <div class="right">
              <button @click="doSearch" class="btn icon search_black">검색</button>
              <!-- <a href="buy_ok"  class="btn icon print">인쇄</a>
              <a href="buy_ok"  class="btn icon excel ">엑셀 다운</a> -->
            </div>
					</div>
          <table class="tbl01 sch_tbl">
					  <tr>
					    <th>구입 기간</th>
              <td>
					      <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_selldtfr" :placeholder="search.iv_selldtfr"/>
              ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_selldtto" :placeholder="search.iv_selldtto"/>
              <br class="mobile"/>
                <s-date-range :fr.sync="search.iv_selldtfr" :to.sync="search.iv_selldtto" />
              </td>
					  </tr>
				</table>


        <s-report :src="report"/>

        <!-- <div class="tbl_w580 ">
          <div class="buy_ok">
            <h1 class="b">경유회비 영수증</h1>
            <div class="b al_c">
               {{ search.iv_selldtfr | moment('YYYY.MM.DD') }} ~ {{ search.iv_selldtto | moment('YYYY.MM.DD') }}
            </div>
            <div class="b h30 mt10">
               회원명 : {{ sitem.membnm }}
            </div>
            <table class="tbl01 via_form">
              <tr>
                <th>구분</th>
                <th>수량</th>
                <th>금액</th>
              </tr>
              <tr>
                <th>본안사건</th>
                <td>{{ sitem.numofcase_1 }}건</td>
                <td>{{ sitem.viafee_1 | comma }}</td>
              </tr>
              <tr>
                <th>
                  민사소액</th>
                <td>{{ sitem.numofcase_2 }}건</td>
                <td>{{ sitem.viafee_2 | comma }}</td>
              </tr>
              <tr>
                <th>
                  민사고액</th>
                  <td>{{ sitem.numofcase_3 }}건</td>
                  <td>{{ sitem.viafee_3 | comma }}</td>
              </tr>
              <tr>
                <th>신청</th>
                <td>{{ sitem.numofcase_6 }}건</td>
                <td>{{ sitem.viafee_6 | comma }}</td>
              </tr>
              <tr>
                <th>등기</th>
                <td>{{ sitem.numofcase_7 }}건</td>
                <td>{{ sitem.viafee_7 | comma }}</td>
              </tr>
              <tr>
                <th>합계</th>
                <th>{{ sitem.numofcase_1
                     + sitem.numofcase_2
                     + sitem.numofcase_3
                     + sitem.numofcase_6
                     + sitem.numofcase_7 | comma }}</th>
                <th>{{ sitem.viafee_1
                     + sitem.viafee_2
                     + sitem.viafee_3
                     + sitem.viafee_6
                     + sitem.viafee_7 | comma }}</th>
              </tr>
              <tr>
                <td colspan="3" class="stemp" >
                  위 금액을 정히 영수함.<br/>
                  {{ $moment().format("YYYY. MM. DD")}} <br/>
                  서울지방변호사회장
                </td>
              </tr>
            </table>
          </div>
          <div class="btn_group print">
            <router-link to="/buy/buy_form" class="btn gray01 outline left">취소</router-link>
            <div class="right">
              <router-link to="/buy/buy_list" class="btn gray01 ">구입 목록</router-link>
              <router-link to="/buy/buy_ok" class="btn gray01 ">인쇄</router-link>
            </div>
          </div>
        </div> -->
			</div> <!-- content : width=950px; -->
</template>

<script>
let ui

export default {
  data() {
    return {
      report : '',
      search : {},
      search_init : {
        iv_selldtfr : this.$moment().add(-1, 'month').format("YYYY-MM-DD")
      , iv_selldtto : this.$moment().format("YYYY-MM-DD")
      , iv_sellregdt : ''
      , iv_sellseq : 0
      },
      sitem : {},
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },

    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    //this.doSearch()
  },
  mounted() {
    // 증표구입내역에서 넘어온 경우 바로 조회
    if (T.isNotEmpty(this.$route.query.sellseq)) {
      this.search.iv_sellregdt   = this.$route.query.sellregdt
      this.search.iv_sellseq     = this.$route.query.sellseq
      this.search.iv_sellpayokdt = this.$route.query.sellpayokdt
      this.doSearch('', 'C')
    }
  },
  methods: {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.report = ''
    },
    doSearch(e, accflag = 'S') {
      // 기간별 조회일 경우
      if (accflag == 'S') {
        if (T.isEmpty(this.search.iv_selldtfr) || T.isEmpty(this.search.iv_selldtto)) {
          return ui.alert("구입기간을 입력해 주세요.")
        }
      }

      // 레포트 출력이므로 날짜 치환해서 보냄
      this.search.iv_selldtfr  = this.search.iv_selldtfr.replace(/-/gi, '')
      this.search.iv_selldtto  = this.search.iv_selldtto.replace(/-/gi, '')
      this.search.iv_accflag   = accflag
      this.search.iv_sellplac  = ''

      // TODO : 레포트 파라미터 세션값으로 넘기지 않도록 수정
      this.search.iv_membno   = this.$store.state.session.user.membno
      this.search.iv_membclsf = this.$store.state.session.user.membclsf

      // 레포트 호출 --- order_receipt.crf --- N_SEL_SELLINFO_DTL
      this.report = "/ClipReport4/order_receipt.jsp?" + T.makeUrlQueryString({
        ..._.pick(this.search, ['iv_accflag','iv_sellplac','iv_sellregdt','iv_sellseq','iv_membnm','iv_membclsf','iv_membno','iv_membaddr','iv_selldtfr','iv_selldtto','iv_sellpayokdt']),
        isfront : 'Y', // 프론트인지 여부
        r: Math.random(),
      })

    },

  },
}
</script>
